import React from 'react';

export default function WorkflowRunProgressPanel({ state, error, title = 'Workflow run', onReset }) {
  if (state.phase === 'idle' && !error) return null;

  return (
    <div className="mt-4 rounded-2xl border border-slate-200 bg-white p-4 shadow-sm md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 pb-3">
        <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        {(state.phase === 'complete' || state.phase === 'error') && onReset ? (
          <button
            type="button"
            onClick={onReset}
            className="text-xs font-medium text-indigo-600 hover:text-indigo-800"
          >
            Dismiss
          </button>
        ) : null}
      </div>

      {error ? (
        <div className="mt-3 rounded-lg bg-red-50 px-3 py-2 text-xs text-red-800" role="alert">
          {error}
        </div>
      ) : null}

      {(state.phase === 'dispatching' || state.phase === 'resolving_run') && (
        <p className="mt-3 text-sm text-indigo-700">Starting workflow…</p>
      )}

      {state.run && (
        <div className="mt-3 space-y-2">
          <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-800">
            <span>
              Status: <strong>{state.run.status}</strong>
              {state.run.conclusion ? (
                <>
                  {' '}
                  · <strong>{state.run.conclusion}</strong>
                </>
              ) : null}
            </span>
            {state.run.html_url ? (
              <a
                href={state.run.html_url}
                target="_blank"
                rel="noreferrer"
                className="font-medium text-indigo-600 hover:underline"
              >
                Open in GitHub ↗
              </a>
            ) : null}
          </div>
          {state.run.name ? <p className="text-xs text-slate-600">{state.run.name}</p> : null}
        </div>
      )}

      {state.phase === 'polling' && !state.run && (
        <p className="mt-3 text-sm text-indigo-700">Loading run details…</p>
      )}

      {state.phase === 'complete' &&
        state.run?.status === 'completed' &&
        state.run?.conclusion === 'success' && (
          <p className="mt-3 text-sm font-medium text-emerald-700">Workflow finished successfully.</p>
        )}
    </div>
  );
}
